import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useMixins } from '@/modules/promotion/plan/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionPlanDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { fetchLinkableItems, getItemName, getItemLink } = useMixins();

    const model = reactive({
        id: route.params?.id,
        name: null,
        status: null,
        timeUnit: 0,
        timeDuration: 0,
        publishTime: null,
        unpublishTime: null,
        itemId: null,
        type: null,
        image: null,
        imageStatus: null,
        canEdit: false,
        canEnable: false,
        canDisable: false,

        get itemName() {
            return getItemName(this.itemId, this.type);
        },
        get itemLink() {
            return getItemLink(this.itemId, this.type);
        }
    });

    const beforeFetch = async () => {
        await fetchLinkableItems();
    };

    const fetch = crudAction.executeAction({
        request: () => promotionService.plan.get(model.id),
        onSuccess: ({ data }) => {
            data.publishTime = new Date(data.publishTime);
            data.unpublishTime = data.unpublishTime ? new Date(data.unpublishTime) : null;
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.PLAN.INDEX })
    });

    const actions = {
        disable: crudAction.confirmAndDisable({
            request: () => promotionService.plan.disable(model.id),
            onSuccess: fetch
        }),
        enable: crudAction.confirmAndEnable({
            request: () => promotionService.plan.enable(model.id),
            onSuccess: fetch
        })
    };

    onMounted(async () => {
        await beforeFetch();
        await fetch();
    });

    return { model, beforeFetch, fetch, actions };
}
